import { Outlet, RouteObject } from 'react-router-dom';
import { LoadsContextProvider } from '../loads/data/LoadsContext';
import { LoadsPageContextProvider } from '../loads/loads-page/data/LoadsPageParamsContext';
import { HomeProvider } from './data/HomeContext';
import { HOME_BASE_PATH } from './data/useHomeBasePath';
import { HomeRouteGuard } from './core/HomeRouteGuard';
import { lazyImport } from 'shared/routing/LazyRoute';

const Home = lazyImport(() => import('./HomePages'), 'Home');
const HomeLoadsList = lazyImport(() => import('./HomePages'), 'HomeLoadsList');

const HomeOutlet = () => {
  return (
    <LoadsPageContextProvider>
      <LoadsContextProvider>
        <HomeProvider>
          <Outlet />
        </HomeProvider>
      </LoadsContextProvider>
    </LoadsPageContextProvider>
  );
};

export function createHomePageRoutes(basePath: string): RouteObject[] {
  return [
    {
      path: basePath,
      element: (
        <HomeRouteGuard basePath={basePath}>
          <HomeOutlet />
        </HomeRouteGuard>
      ),
      children: [
        {
          index: true,
          element: <Home />,
        },
      ],
    },
    {
      path: `${basePath}/loads`,
      element: (
        <HomeRouteGuard basePath={basePath}>
          <LoadsPageContextProvider>
            <LoadsContextProvider>
              <HomeLoadsList />
            </LoadsContextProvider>
          </LoadsPageContextProvider>
        </HomeRouteGuard>
      ),
    },
  ];
}

export const homeRoutes: RouteObject[] = createHomePageRoutes(HOME_BASE_PATH);
